import React from "react";

const WhyChooseUs11 = ({ data }) => {
  const leftCards = Array.from({ length: 10 }, (_, i) => i + 1);
  const rightCards = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div
      className="why_choose_us_11"
      style={{ backgroundImage: `url(${data?.bgImgold})` }}
    >
      {/* Top Heading Section */}
      <div className="width90 maxWidth700 floatCenter textCenter">
        {data?.smallHead && (
          <p className="smallHead">
            <span className="round-subtitle-shape"></span>
            {data.smallHead}
          </p>
        )}

        <p
          className="mainHeading"
          dangerouslySetInnerHTML={{ __html: data?.mainHeading }}
        />

        <p className="subPara">{data?.subPara}</p>
      </div>

      {/* Cards Section */}
      <div className="width90 maxWidth1100 floatCenter">
        <div className="grid grid2 gap20">
          {/* Left Card */}
          <div className="cardMain">
            <p className="cardMainHead textCenter">{data?.leftHead}</p>
            <p className="cardOutPara textCenter">{data?.leftPara}</p>

            <div className="innerCard flex flexColumn gap20 relative">
              {leftCards.map(
                (i) =>
                  data?.[`cardPara1${i}`] && (
                    <div key={i} className="cardSec">
                      <div className="grid custGrid gap20">
                        <div className="iconSec flex alignCenter justifyCenter">
                          <i className="fa-solid fa-circle-check"></i>
                        </div>

                        <div className="textSec">
                          <p className="cardHead">
                            {data?.[`cardHead1${i}`]}
                          </p>
                          <p className="cardPara">
                            {data?.[`cardPara1${i}`]}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div>

            {data?.btnText1 && (
              <div className="textCenter">
                <a href={data?.btnLink1} title={data?.btnText1}>
                  <button className="btn mrgTop30">
                    {data?.btnText1}
                  </button>
                </a>
              </div>
            )}
          </div>

          {/* Right Card */}
          <div className="cardMain">
            <p className="cardMainHead textCenter">
              {data?.rightHeading}
            </p>
            <p className="cardOutPara textCenter">
              {data?.rightPara}
            </p>

            <div className="innerCard flex flexColumn gap20 relative">
              {rightCards.map(
                (i) =>
                  data?.[`cardPara2${i}`] && (
                    <div key={i} className="cardSec">
                      <div className="grid custGrid gap20">
                        <div className="iconSec flex alignCenter justifyCenter">
                          <i className="fa-solid fa-circle-check"></i>
                        </div>

                        <div className="textSec">
                          <p className="cardHead">
                            {data?.[`cardHead2${i}`]}
                          </p>
                          <p className="cardPara">
                            {data?.[`cardPara2${i}`]}
                          </p>
                        </div>
                      </div>
                    </div>
                  )
              )}
            </div>

            {data?.btnText2 && (
              <div className="textCenter">
                <a href={data?.btnLink2} title={data?.btnText2}>
                  <button className="btn mrgTop30">
                    {data?.btnText2}
                  </button>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Bottom Button */}
      {data?.btnText && (
        <div className="btnSec textCenter">
          <a href={data?.btnLink}>
            <button className="btn">{data?.btnText}</button>
          </a>
        </div>
      )}
    </div>
  );
};

export default WhyChooseUs11;